import { ReactNode, useEffect } from 'react';
import { FileConfigurationContext } from './FileConfigurationContext';
import useFetchFileConfigurations from '@/hooks/useApi/useFetchFileConfigurations';
import { useToast } from '@/providers/Toast.provider';

export default function FileConfigurationProvider({ children }: { children: ReactNode }) {
  const toast = useToast();
  const { configurations, configurationsLoading, fetchFileConfigurations } = useFetchFileConfigurations();

  useEffect(() => {
    init();
  }, []);

  async function init() {
    try {
      await fetchFileConfigurations();
    } catch (err) {
      if (err instanceof Error) {
        toast.neutral(err.message);
      }
    }
  }

  return (
    <FileConfigurationContext.Provider
      value={{
        configurations,
        configurationsLoading,
      }}
    >
      {children}
    </FileConfigurationContext.Provider>
  );
}
